import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../../ui/button/Button";
import SelectAutoComplete from "../../../ui/selectAutoComplete/SelectAutoComplete";
import { useState, useEffect } from "react";
import {
  getTiposEquipo,
  getTiposTensionEquipo,
  getVoltajesEquiposMedicionPorTipoTension,
} from "../../../components/functions/Soporte";

const NuevoEquipoMedicionModal = ({
  open,
  onClose,
  onConfirm,
  API_URL,
  equipo = null,
}) => {
  const [equiposForm, setEquiposForm] = useState({});

  const [tiposTension, setTiposTension] = useState([]);
  const [voltajes, setVoltajes] = useState([]);
  const [tiposEquipos, setTiposEquipos] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [tipoTensionEquipo, setTipoTensionEquipo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const voltajesRes = await getVoltajesEquiposMedicionPorTipoTension(
        API_URL,
        tipoTensionEquipo.name
      );

      const v = voltajesRes.map((voltaje) => ({
        label: voltaje.toString(),
        value: voltaje.toString(),
      }));

      setEquiposForm({
        ...equiposForm,
        voltaje: null,
      });

      setVoltajes(v);
    };

    if (tipoTensionEquipo) {
      fetchData();
    }
  }, [tipoTensionEquipo]);

  useEffect(() => {
    const fetchData = async () => {
      const [tiposEquiposRes, getTiposTensionEquipoRes] = await Promise.all([
        getTiposEquipo(API_URL),
        getTiposTensionEquipo(API_URL),
      ]);

      setTiposEquipos(tiposEquiposRes);
      setTiposTension(getTiposTensionEquipoRes);
    };

    if (open) {
      fetchData();
    }
    if (equipo) {
      setEquiposForm({
        ...equipo,
        voltaje: {
          label: equipo.voltaje.toString(),
          value: equipo.voltaje.toString(),
        },
      });
    }
  }, [open]);

  const handleClose = () => {
    onClose();
    setEquiposForm({});
    setTiposEquipos([]);
    setVoltajes([]);
    setTiposTension([]);
  };

  const handleConfirm = async () => {
    if (
      !equiposForm?.tipoEquipo ||
      !equiposForm?.tipoTensionEquipo ||
      !equiposForm?.voltaje ||
      !equiposForm?.equipo ||
      !equiposForm?.corrienteMin ||
      !equiposForm?.corrienteMax
    ) {
      setShowSnackbar(true);
      setSnackbarMessage("Por favor, complete todos los campos obligatorios.");
      return;
    }
    const payload = {
      ...equiposForm,
      voltaje: Number(equiposForm.voltaje.label),
      corrienteMin: Number(equiposForm.corrienteMin),
      corrienteMax: Number(equiposForm.corrienteMax),
    };
    onConfirm(payload);
    handleClose();
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>
        {equipo ? "Editar" : "Registrar"} Equipo de Medición
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "16px",
          }}
        >
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Nombre del equipo (W) *</label>
            <input
              className="form-input"
              placeholder="Nombre..."
              value={equiposForm?.equipo || ""}
              onChange={(e) => {
                setEquiposForm((prev) => ({
                  ...prev,
                  equipo: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div>
            <label className="form-label">Tipo de tensión *</label>
            <SelectAutoComplete
              label=""
              fieldC="descripcion"
              options={tiposTension}
              value={equiposForm.tipoTensionEquipo}
              onChange={(e, value) => {
                setEquiposForm((prev) => ({
                  ...prev,
                  tipoTensionEquipo: value,
                }));
                setTipoTensionEquipo(value);
              }}
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
          <div>
            <label className="form-label">Voltaje (V) *</label>
            <SelectAutoComplete
              label=""
              options={voltajes}
              value={equiposForm.voltaje}
              onChange={(e, value) =>
                setEquiposForm((prev) => ({ ...prev, voltaje: value }))
              }
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
          <div>
            <label className="form-label">Corriente mínima (A) *</label>
            <input
              className="form-input"
              placeholder="Corriente..."
              value={equiposForm?.corrienteMin || ""}
              onChange={(e) => {
                setEquiposForm((prev) => ({
                  ...prev,
                  corrienteMin: e.target.value,
                }));
              }}
              style={{ color: "black" }}
              type="number"
            />
          </div>
          <div>
            <label className="form-label">Corriente máxima (A) *</label>
            <input
              className="form-input"
              placeholder="Corriente..."
              value={equiposForm?.corrienteMax || ""}
              onChange={(e) => {
                setEquiposForm((prev) => ({
                  ...prev,
                  corrienteMax: e.target.value,
                }));
              }}
              style={{ color: "black" }}
              type="number"
            />
          </div>
          <div>
            <label className="form-label">Tipo de equipo *</label>
            <SelectAutoComplete
              label=""
              fieldC="name"
              options={tiposEquipos}
              value={equiposForm.tipoEquipo}
              onChange={(e, value) =>
                setEquiposForm((prev) => ({ ...prev, tipoEquipo: value }))
              }
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
          <div>
            <label className="form-label">REL TC</label>
            <input
              className="form-input"
              placeholder="REL..."
              value={equiposForm?.relacionTransformacionCorriente || ""}
              onChange={(e) => {
                setEquiposForm((prev) => ({
                  ...prev,
                  relacionTransformacionCorriente: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default NuevoEquipoMedicionModal;
